import { createIntentType } from './intent';
export function createObjectIntentType(label, create, assign = Object.assign) {
    return createIntentType(label, {
        add (intent, state = {}) {
            assign(state, intent);
            return state;
        },
        create,
        merge (target, source) {
            const result = target !== null && target !== void 0 ? target : {};
            assign(result, source);
            return result;
        }
    });
}

//# sourceMappingURL=createObjectIntentType.js.map